import { createSlice } from '@reduxjs/toolkit';

const resetState = {
  isCardHolderDetailsOpen: false,
  paymentInputValue: 0,
  selectedPaymentType: null,
};

const paymentFormSlice = createSlice({
  name: 'paymentForm',
  initialState: {
    ...resetState,
  },
  reducers: {
    setIsCardHolderDetailsOpen: (reduxState, { payload = {} }) => {
      reduxState.isCardHolderDetailsOpen = payload;
    },
    setPaymentInputValue: (reduxState, { payload = {} }) => {
      reduxState.paymentInputValue = payload;
    },
    setSelectedPaymentType: (reduxState, { payload = {} }) => {
      reduxState.selectedPaymentType = payload;
    },
    resetPaymentFormSlice: (reduxState) => {
      Object.assign(reduxState, resetState);
    },
  },
});

export const { setIsCardHolderDetailsOpen, setPaymentInputValue, resetPaymentFormSlice, setSelectedPaymentType } =
  paymentFormSlice.actions;

export { resetState as paymentFormResetState };

export default paymentFormSlice.reducer;